import { render, staticRenderFns } from "./bestSelling.vue?vue&type=template&id=415ececa&"
import script from "./bestSelling.vue?vue&type=script&lang=js&"
export * from "./bestSelling.vue?vue&type=script&lang=js&"
import style0 from "./bestSelling.vue?vue&type=style&index=0&id=415ececa&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('415ececa')) {
      api.createRecord('415ececa', component.options)
    } else {
      api.reload('415ececa', component.options)
    }
    module.hot.accept("./bestSelling.vue?vue&type=template&id=415ececa&", function () {
      api.rerender('415ececa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/SalesStatistics/bestSelling.vue"
export default component.exports